// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('UserRightDefVO')
export class UserRightDefVO {
  @JsonProperty('name', 'String')
  public name: string = undefined;

  @JsonProperty('description', 'String')
  public description: string = undefined;

  @JsonProperty('visible', 'Boolean')
  public visible: boolean = undefined;
}
